<script module>
	export class ClaimRecord {
		constructor(data) {
			this.claimId = data.claimId;
			this.digest = data.digest;
			this.isHistoricalEob = data.isHistoricalEob;
			this.documentEntryId = data.documentEntryId;
			this.documentEntryExtension = data.documentEntryExtension;
			this.serviceDate = data.serviceDate
				? new Date(data.serviceDate)
						.toLocaleDateString("en-US")
						.split("T")[0]
				: "";
			this.patientName = data.patientName;
			this.providerName = data.providerName;
			this.chargedAmount = data.chargedAmount;
			this.paidAmount = data.paidAmount;
			this.paidDate = data.paidDate
				? new Date(data.paidDate)
						.toLocaleDateString("en-US")
						.split("T")[0]
				: "";
			this.coPay = data.coPay;
			this.isAppealed = data.isAppealed;
			this.totalResponsibility = data.totalResponsibility;
			this.ineligibleAmount = data.ineligibleAmount;
			this.otherInsurance = data.otherInsurance;
			this.deductible = data.deductible;
			this.coInsurance = data.coInsurance;
			this.hasEob = data.hasEob;
			this.claimStatus = data.claimStatus;

			if (data.appealDetail) {
				this.appealEnteredDate = data.appealDetail.enteredDate
					? new Date(data.appealDetail.enteredDate)
							.toLocaleDateString("en-US")
							.split("T")[0]
					: "";
				this.appealReceivedDate = data.appealDetail.receivedDate
					? new Date(data.appealDetail.receivedDate)
							.toLocaleDateString("en-US")
							.split("T")[0]
					: "";
				this.appealResolvedDate = data.appealDetail.resolvedDate
					? new Date(data.appealDetail.resolvedDate)
							.toLocaleDateString("en-US")
							.split("T")[0]
					: "";
				this.appealOutcome = data.appealDetail.outcome;
			}
		}
	}
</script>

<script>
	let { claimRecord = null, hasAnyAppeals = false, onDownloadEob } = $props();

	let item = claimRecord;
	let showExpandedView = $state(false);

	function handleEobClick() {
		if (onDownloadEob) {
			onDownloadEob(item);
		}
	}

	function toggleExpandedView() {
		showExpandedView = !showExpandedView;
	}
</script>

<tr>
	<td onclick={toggleExpandedView} class="hover-hand">
		<i class="fa {showExpandedView ? 'fa-minus-square-o' : 'fa-plus-square-o'}"></i>
	</td>
	<td>{item.serviceDate}</td>
	<td>{item.paidDate}</td>
	{#if item.hasEob}
		<td onclick={handleEobClick} class="hover-hand text-center">
			<i class="pdf-lg"></i>
		</td>
	{:else}
		<td></td>
	{/if}
	
	<td>{item.providerName}</td>
	<td class="patient-name">{item.patientName}</td>
	<td class="text-end">{item.totalResponsibility}</td>
	<td>{item.claimStatus}</td>

	{#if hasAnyAppeals}
		<td>
			{#if item.isAppealed}
				<i onclick={toggleExpandedView} class="fa fa-flag-o hover-hand"></i>
			{/if}
		</td>
	{/if}
</tr>
{#if showExpandedView}
	<tr class="expandedView">
		<td colspan="9">
			<div class="expandedTable">
				<p>Amount Charged: <strong>{item.chargedAmount}</strong></p>
				<p>Date Paid: <strong>{item.paidDate}</strong></p>
				<p>Claim Number: <strong>{item.claimId?.toUpperCase()}</strong></p>
				<table class="table table-striped table-bordered detailTable">
					<tbody>
						<tr>
							<th class="text-end"><strong>Deductible</strong></th>
							<th class="text-end"><strong>Coinsurance</strong></th>
							<th class="text-end"><strong>Copay</strong></th>
							<th class="text-end"><strong>Other Insurance</strong></th>
							<th class="text-end"><strong>Amount Paid</strong></th>
						</tr>
						<tr>
							<td class="text-end">{item.deductible}</td>
							<td class="text-end">{item.coInsurance}</td>
							<td class="text-end">{item.coPay}</td>
							<td class="text-end">{item.otherInsurance}</td>
							<td class="text-end">{item.paidAmount}</td>
						</tr>
					</tbody>
				</table>
				{#if item.isAppealed}
					<br />
					<h5>Appeal Details</h5>
					<table class="table table-striped table-bordered detailTable">
						<tbody>
							<tr>
								<th>Date Received</th>
								<th>Date Entered</th>
								<th>Date Resolved</th>
								<th>Outcome</th>
							</tr>
							<tr>
								<td>{item.appealReceivedDate}</td>
								<td>{item.appealEnteredDate}</td>
								<td>{item.appealResolvedDate}</td>
								<td>{item.appealOutcome}</td>
							</tr>
						</tbody>
					</table>
				{/if}
			</div>
		</td>
	</tr>
{/if}
